import Dividends from './DividentsContainer';

export default Dividends;
